import "bootstrap/dist/css/bootstrap.min.css"
import "./App.css"
import Menu from "./components/Navbar"
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom"
import Footer from "./components/Footer"
import Homepage from "./components/Homepage"
import OfficePresentation from "./components/OfficePresentation"
import BalneoPresentation from "./components/BalneoPresentation"
import ContactUs from "./components/ContactUs"
import PrivatePolicy from "./components/PrivatePolicy"

function App() {
	return (
		<BrowserRouter>
			<Menu />

			<Routes>
				<Route path="/" element={<Homepage />} />
				<Route path="/le-cabinet" element={<OfficePresentation />} />
				<Route path="/balneotherapie" element={<BalneoPresentation />} />
				<Route path="/contact" element={<ContactUs />} />
				<Route path="/mentions-legales" element={<PrivatePolicy />} />
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>

			<Footer />
		</BrowserRouter>
	)
}

export default App
